// src/elements/Input/context.ts
import { createContext } from "react";
var InputContext = createContext({});
export { InputContext };